<button [id]="'tab-' + tab.code" class="btn btn-link btn-option" attr.aria-label="{{tab.title | translate}}" tabindex="0">
	<span *ngIf="iconMap[tab.code]" class="btn-option-icon">
	   <i class="fa no-margin" [ngClass]="iconMap[tab.code]" aria-hidden="true"></i>
	</span>
	<span *ngIf="imgMap[tab.code]" class="btn-option-img">
		<img [src]="imgMap[tab.code]" alt="{{tab.title | translate}}">
	</span>
   <span class="btn-option-name">{{tab.title | translate}}</span>
</button>